import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import app from './app';
import goods from './goods';
import currentOrder from './currentOrder';
import translation from './translation';
import priceRequestMessage from './priceRequestMessage';

export default history =>
  combineReducers({
    router: connectRouter(history),
    app,
    goods,
    currentOrder,
    translation,
    priceRequestMessage
  });
